/**
 * CLK Collection/Search AJAX Filters
 * Section Rendering API + interceptors + reinits + bestseller + in-page search
 */
(function () {
  if (window.__clkAjaxFiltersInstalled) return;
  window.__clkAjaxFiltersInstalled = true;

  var FREE_SHIPPING_CENTS = 15000;
  var BEST_SELLER_COLLECTION_HANDLE = 'best-seller';
  var BEST_SELLER_SORT_VALUE = 'best-selling';
  var ORDER_COUNT_ATTR = 'data-order-count';
  var LOCALSTORAGE_VIEW_KEY = 'collectionView';
  var IN_COLLECTION_INPUT_ID = 'searchajaxcollpditm';
  var IN_COLLECTION_DEBOUNCE_MS = 300;

  var config = {};
  var PRODUCT_GRID_SECTION_ID = '';
  var PRODUCT_GRID_SELECTOR = '.collection--section, .search--section';

  var fetching = false;
  var missingLogged = {};

  function readConfig() {
    var el = document.getElementById('clk-ajax-filters-config');
    if (!el) return config;
    try {
      config = JSON.parse(el.textContent);
    } catch (e) {
      return config;
    }
    if (config.sectionId) {
      PRODUCT_GRID_SECTION_ID = config.sectionId;
      PRODUCT_GRID_SELECTOR = '#shopify-section-' + PRODUCT_GRID_SECTION_ID;
    }
    window.__clkAjaxFiltersConfig = config;
    return config;
  }

  readConfig();

  function warnOnce(key, msg) {
    if (missingLogged[key]) return;
    missingLogged[key] = true;
    console.warn('[CLK ajax filters]', msg);
  }

  function getSectionEl() {
    var el = document.querySelector(PRODUCT_GRID_SELECTOR);
    if (!el) warnOnce('section', 'Product grid section not found: ' + PRODUCT_GRID_SELECTOR);
    return el;
  }

  function buildFetchURL(pageURL) {
    var url = new URL(pageURL, window.location.origin);
    if (PRODUCT_GRID_SECTION_ID) {
      url.searchParams.set('section_id', PRODUCT_GRID_SECTION_ID);
    }
    return url.toString();
  }

  function showLoading(section) {
    if (section) section.classList.add('clk-ajax-filters-loading');
  }

  function hideLoading(section) {
    if (section) section.classList.remove('clk-ajax-filters-loading');
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function formatMoney(cents) {
    var value = Number(cents) || 0;
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try {
        return window.Shopify.formatMoney(
          value,
          config.moneyFormat || window.Shopify.money_format || '${{amount}}'
        );
      } catch (e) {
        /* fall through */
      }
    }
    return '$' + (value / 100).toFixed(2);
  }

  /* ---------- Module E: lazy images ---------- */
  function reinitLazyImages(section) {
    if (!section) return;
    var imgs = section.querySelectorAll('img[data-rimg="lazy"], img[data-rimg="loading"]');
    imgs.forEach(function (img) {
      var template = img.getAttribute('data-rimg-template');
      var max = img.getAttribute('data-rimg-max') || '600x600';
      if (template) {
        var src = template.replace('{size}', max).replace('{width}', '600');
        img.setAttribute('src', src);
        if (img.hasAttribute('srcset')) {
          img.removeAttribute('srcset');
        }
      }
      img.setAttribute('data-rimg', 'loaded');
      img.removeAttribute('loading');
    });
    section.querySelectorAll('div[data-rimg-canvas]').forEach(function (el) {
      el.style.display = 'none';
    });
  }

  /* ---------- Module C: bestseller DOM sort ---------- */
  function sortByOrderCount(section) {
    var url = new URL(window.location.href);
    if (url.searchParams.get('sort_by') !== BEST_SELLER_SORT_VALUE) return;

    var root = section || getSectionEl();
    if (!root) return;

    var grid =
      root.querySelector('[data-productgrid-items]') ||
      root.querySelector('.productgrid--items') ||
      root.querySelector('ul.productgrid--items');
    if (!grid) return;

    var items = Array.prototype.slice.call(grid.querySelectorAll(':scope > [data-product-item]'));
    if (items.length < 2) return;

    items.sort(function (a, b) {
      var aCount = parseInt(a.getAttribute(ORDER_COUNT_ATTR), 10) || 0;
      var bCount = parseInt(b.getAttribute(ORDER_COUNT_ATTR), 10) || 0;
      return bCount - aCount;
    });

    var frag = document.createDocumentFragment();
    items.forEach(function (item) {
      frag.appendChild(item);
    });
    grid.appendChild(frag);
  }

  /* ---------- Module: grid/list view ---------- */
  function applySavedView(section) {
    var root = section || getSectionEl();
    if (!root) return;
    var outer =
      root.querySelector('[data-productgrid-outer]') ||
      root.querySelector('.productgrid--outer') ||
      document.querySelector('[data-productgrid-outer]') ||
      document.querySelector('.productgrid--outer');
    if (!outer) return;

    var saved = null;
    try {
      saved = localStorage.getItem(LOCALSTORAGE_VIEW_KEY);
    } catch (e) {
      saved = null;
    }

    if (saved === 'list-view') {
      outer.classList.add('productgrid-listview');
    } else if (saved === 'grid-view') {
      outer.classList.remove('productgrid-listview');
    }

    root.querySelectorAll('[data-collection-view]').forEach(function (btn) {
      var view = btn.getAttribute('data-collection-view');
      btn.classList.toggle('active', view === saved || (!saved && btn.classList.contains('active')));
      if (saved) btn.classList.toggle('active', view === saved);
    });
  }

  function setCollectionView(view) {
    try {
      localStorage.setItem(LOCALSTORAGE_VIEW_KEY, view);
    } catch (e) {
      /* ignore */
    }
    applySavedView(getSectionEl());
  }

  /* ---------- Module G: Quick Buy fallback ---------- */
  function reinitQuickBuyButtons(section) {
    var root = section || getSectionEl();
    if (!root) return;

    root.querySelectorAll('[data-quick-buy]').forEach(function (btn) {
      var clone = btn.cloneNode(true);
      btn.parentNode.replaceChild(clone, btn);

      clone.addEventListener('click', function (evt) {
        // Prefer existing theme / qty-rules handlers if present
        if (window.theme && (window.theme.QuickBuy || window.AddToCartFlyout)) {
          return;
        }

        evt.preventDefault();
        evt.stopPropagation();

        var variantId = clone.getAttribute('data-variant-id');
        if (!variantId) return;

        var card = clone.closest('[data-product-item]');
        var qtyInput = card && card.querySelector('.quantity-selector__input, [name="quantity"]');
        var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

        var originalText = clone.textContent;
        clone.disabled = true;
        clone.textContent = 'Adding…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: Number(variantId), quantity: qty }),
        })
          .then(function (res) {
            if (!res.ok) throw new Error('ATC failed');
            return res.json();
          })
          .then(function () {
            clone.textContent = 'Added!';
            return fetch('/cart.js').then(function (r) {
              return r.json();
            });
          })
          .then(function (cart) {
            showAtcBanner(card, qty, cart);
            if (window.theme && window.theme.Cart) {
              if (typeof window.theme.Cart.getCart === 'function') window.theme.Cart.getCart();
              if (typeof window.theme.Cart.open === 'function') window.theme.Cart.open();
            }
            document.dispatchEvent(new CustomEvent('cartcount:update', { detail: { item_count: cart.item_count } }));
          })
          .catch(function () {
            clone.textContent = originalText;
          })
          .finally(function () {
            setTimeout(function () {
              clone.disabled = false;
              clone.textContent = originalText;
            }, 1200);
          });
      });
    });
  }

  function showAtcBanner(card, qty, cart) {
    var header = document.querySelector('header') || document.querySelector('.site-header-wrapper');
    if (!header) return;

    var existing = document.querySelector('.clk-ajax-atc-banner');
    if (existing) existing.remove();

    var title =
      (card && card.querySelector('.productitem--title'))
        ? card.querySelector('.productitem--title').textContent.trim()
        : 'Product';
    var imgEl = card && card.querySelector('figure img, .productitem--image img, img');
    var img = imgEl ? imgEl.getAttribute('src') || '' : '';
    var priceEl = card && (card.querySelector('.money[data-price]') || card.querySelector('.money'));
    var priceText = priceEl ? priceEl.textContent.trim() : '';

    var ship = 0;
    var percentage = 100;
    if (cart.total_price < FREE_SHIPPING_CENTS) {
      ship = FREE_SHIPPING_CENTS - cart.total_price;
      percentage = ((cart.total_price / FREE_SHIPPING_CENTS) * 100).toFixed(0);
    }

    var banner = document.createElement('div');
    banner.className = 'clk-ajax-atc-banner atc-banner';
    banner.innerHTML =
      '<div class="atc-banner--container" style="padding:12px 16px;background:#fff;border-bottom:1px solid #eee;">' +
      '<button type="button" class="clk-ajax-atc-close" aria-label="Close" style="float:right;border:0;background:transparent;font-size:20px;cursor:pointer;">&times;</button>' +
      '<div>Added to your cart:</div>' +
      '<div style="display:flex;gap:12px;margin-top:8px;align-items:center;">' +
      (img
        ? '<img src="' + escapeHtml(img) + '" alt="" width="60" height="60" style="object-fit:cover;">'
        : '') +
      '<div>' +
      '<div class="atc--product-details--title">' +
      escapeHtml(title) +
      '</div>' +
      '<div class="atc--product-details--price-quantity">' +
      escapeHtml(String(qty)) +
      ' × <span class="atc--product-details--price-value money">' +
      escapeHtml(priceText) +
      '</span></div>' +
      '</div></div>' +
      '<div style="margin-top:8px;">Subtotal: ' +
      escapeHtml(formatMoney(cart.total_price)) +
      '</div>' +
      (ship > 0
        ? '<div style="margin-top:6px;">' +
          escapeHtml(formatMoney(ship)) +
          ' away from free shipping!</div>' +
          '<div style="height:6px;background:#eee;margin-top:6px;"><div style="height:100%;width:' +
          percentage +
          '%;background:#f15a22;"></div></div>'
        : '<div style="margin-top:6px;">You qualify for free shipping!</div>') +
      '<div style="margin-top:10px;display:flex;gap:12px;">' +
      '<a href="/cart">View cart</a>' +
      '<a href="/checkout">Checkout</a>' +
      '</div></div>';

    header.insertAdjacentElement('afterend', banner);
    banner.querySelector('.clk-ajax-atc-close').addEventListener('click', function () {
      banner.remove();
    });
  }

  /* ---------- Module F: product card reinit ---------- */
  function reinitProductCards(section) {
    var root = section || getSectionEl();
    if (!root) return;

    if (window.theme) {
      try {
        if (window.theme.ProductItem && typeof window.theme.ProductItem.init === 'function') {
          window.theme.ProductItem.init(root);
        }
        if (window.theme.QuickShop && typeof window.theme.QuickShop.init === 'function') {
          window.theme.QuickShop.init(root);
        }
        if (window.theme.QuickBuy && typeof window.theme.QuickBuy.init === 'function') {
          window.theme.QuickBuy.init(root);
        }
        if (window.theme.WishList && typeof window.theme.WishList.init === 'function') {
          window.theme.WishList.init(root);
        }
      } catch (e) {
        /* ignore theme API errors */
      }
    }
    if (window.WishlistHero && typeof window.WishlistHero.refresh === 'function') {
      try {
        window.WishlistHero.refresh();
      } catch (e) {
        /* ignore */
      }
    }

    root.querySelectorAll('quantity-selector').forEach(function (node) {
      var clone = node.cloneNode(true);
      node.parentNode.replaceChild(clone, node);
    });

    var listView = document.querySelector('.productgrid-listview');
    if (!listView) {
      root.querySelectorAll('[data-product-item]').forEach(function (card) {
        if (card._clkHoverBound) return;
        card._clkHoverBound = true;
        card.addEventListener('mouseenter', function () {
          if (document.querySelector('.productgrid-listview')) return;
          card.classList.add('productitem--hovered');
          card.setAttribute('data-animation-state', 'open');
        });
        card.addEventListener('mouseleave', function () {
          card.classList.remove('productitem--hovered');
          card.setAttribute('data-animation-state', 'closed');
        });
      });
    }

    reinitQuickBuyButtons(root);
  }

  function reexecInlineScripts(section) {
    if (!section) return;
    readConfig();
    section.querySelectorAll('script').forEach(function (oldScript) {
      if (oldScript.type === 'application/json' || oldScript.type === 'application/ld+json') return;
      if (oldScript.type && oldScript.type !== 'text/javascript' && oldScript.type !== '') return;
      if (oldScript.src && oldScript.src.indexOf('clk-ajax-filters') !== -1) return;

      var script = document.createElement('script');
      if (oldScript.src) {
        script.src = oldScript.src;
      } else {
        script.textContent = oldScript.textContent;
      }
      oldScript.parentNode.replaceChild(script, oldScript);
    });
  }

  function afterRender(section) {
    hideLoading(section);
    if (section && typeof section.scrollIntoView === 'function') {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    reinitLazyImages(section);
    reinitProductCards(section);
    applySavedView(section);
    sortByOrderCount(section);
    if (typeof window.initCollectionSearch === 'function') {
      window.initCollectionSearch();
    }
    reexecInlineScripts(section);
  }

  /* ---------- Module A: fetchAndRender ---------- */
  function fetchAndRender(newURL) {
    if (fetching) return;
    var section = getSectionEl();
    if (!section) {
      window.location = newURL;
      return;
    }

    fetching = true;
    showLoading(section);

    fetch(buildFetchURL(newURL), {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then(function (res) {
        if (!res.ok) throw new Error(String(res.status));
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next =
          (PRODUCT_GRID_SECTION_ID &&
            doc.querySelector('#shopify-section-' + PRODUCT_GRID_SECTION_ID)) ||
          doc.querySelector(PRODUCT_GRID_SELECTOR) ||
          doc.body;
        if (!next) throw new Error('Missing section in response');

        section.innerHTML = next.innerHTML;

        // Keep config in sync if loader snippet re-injected
        var cfgScript = section.querySelector('script');
        void cfgScript;

        history.pushState({}, '', newURL);
        afterRender(section);
      })
      .catch(function (err) {
        console.warn('[CLK ajax filters] fetch failed, hard navigating', err);
        window.location = newURL;
      })
      .finally(function () {
        fetching = false;
      });
  }

  /* ---------- Module B: event interception ---------- */
  function isFilterNavLink(anchor) {
    if (!anchor || !anchor.getAttribute) return false;
    if (anchor.hasAttribute('data-filter-input')) return true;
    if (anchor.classList.contains('active-filter-group__item')) return true;
    if (anchor.classList.contains('filter-item-clear-all')) return true;
    if (anchor.closest('.pagination--inner') && anchor.tagName === 'A') return true;
    return false;
  }

  function isFacetFilterLink(anchor) {
    if (!anchor || !anchor.getAttribute) return false;
    if (anchor.hasAttribute('data-filter-input')) return true;
    if (anchor.classList.contains('active-filter-group__item')) return true;
    if (anchor.classList.contains('filter-item-clear-all')) return true;
    return false;
  }

  /* Facet check/uncheck: drop sort_by so Shopify uses collection default order */
  function collectionDefaultFilterURL(href) {
    var url = new URL(href, window.location.origin);
    url.searchParams.delete('sort_by');
    url.searchParams.delete('page');
    return url.pathname + url.search;
  }

  document.addEventListener(
    'click',
    function (evt) {
      var target = evt.target;
      if (!target || !target.closest) return;

      var viewBtn = target.closest('[data-collection-view]');
      if (viewBtn) {
        var view = viewBtn.getAttribute('data-collection-view');
        if (view) setCollectionView(view);
        return;
      }

      var sortBtn = target.closest('[data-productgrid-trigger-sort-button]');
      if (sortBtn) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        var sortValue = sortBtn.getAttribute('value') || sortBtn.getAttribute('data-value');
        if (!sortValue) return;
        var sortUrl = new URL(window.location.href);
        sortUrl.searchParams.set('sort_by', sortValue);
        sortUrl.searchParams.delete('page');
        var modal = document.querySelector('.utils-sortby--modal');
        if (modal) modal.setAttribute('aria-hidden', 'true');
        fetchAndRender(sortUrl.pathname + sortUrl.search);
        return;
      }

      var anchor = target.closest('a');
      if (!anchor || !anchor.href) return;
      if (!isFilterNavLink(anchor)) return;
      if (anchor.target === '_blank') return;

      evt.preventDefault();
      evt.stopImmediatePropagation();

      var nextUrl = isFacetFilterLink(anchor)
        ? collectionDefaultFilterURL(anchor.href)
        : anchor.href;
      fetchAndRender(nextUrl);
    },
    true
  );

  document.addEventListener(
    'change',
    function (evt) {
      var select = evt.target;
      if (!select || !select.matches) return;
      if (!select.matches('select[data-productgrid-trigger-sort]')) return;

      evt.preventDefault();
      evt.stopImmediatePropagation();

      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      fetchAndRender(url.pathname + url.search);
    },
    true
  );

  window.addEventListener('popstate', function () {
    fetchAndRender(window.location.href);
  });

  /* ---------- Module H: in-collection title search ---------- */
  function runCollectionTitleFilter(query) {
    var q = String(query || '')
      .trim()
      .toLowerCase();
    var section = getSectionEl();
    if (!section) return;

    var grid =
      section.querySelector('[data-productgrid-items]') ||
      section.querySelector('.productgrid--items');
    if (!grid) return;

    var cards = section.querySelectorAll('[data-product-item]');
    var visibleCount = 0;

    cards.forEach(function (card) {
      var titleEl = card.querySelector('.productitem--title');
      var title = titleEl ? titleEl.textContent.toLowerCase() : '';
      var match = !q || title.indexOf(q) !== -1;
      card.classList.toggle('clk-product-hidden', !match);
      card.style.display = '';
      if (match) visibleCount += 1;
    });

    // nth-child gutters break when items are hidden — use gap layout while filtering
    grid.classList.toggle('clk-in-collection-filtering', !!q);
    grid.classList.toggle('clk-in-collection-empty', !!q && visibleCount === 0);
  }

  function initCollectionSearch() {
    var input = document.getElementById(IN_COLLECTION_INPUT_ID);
    if (!input) return;

    if (typeof window.__clkInCollectionQuery === 'string') {
      input.value = window.__clkInCollectionQuery;
      runCollectionTitleFilter(window.__clkInCollectionQuery);
    }

    if (input._searchBound) return;
    input._searchBound = true;

    var debounceTimer = null;
    function schedule() {
      window.__clkInCollectionQuery = input.value;
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        runCollectionTitleFilter(input.value);
      }, IN_COLLECTION_DEBOUNCE_MS);
    }

    input.addEventListener('input', schedule);
    input.addEventListener('keydown', function (evt) {
      if (evt.key === 'Enter') {
        evt.preventDefault();
        window.__clkInCollectionQuery = input.value;
        runCollectionTitleFilter(input.value);
      }
    });

    var btn = document.querySelector('.boost-pfs-in-collection-search-button');
    if (btn && !btn._searchBound) {
      btn._searchBound = true;
      btn.addEventListener('click', function () {
        window.__clkInCollectionQuery = input.value;
        runCollectionTitleFilter(input.value);
      });
    }
  }

  window.initCollectionSearch = initCollectionSearch;

  /* ---------- Module D: force best-seller sort ---------- */
  (function forceBestSellerSort() {
    try {
      var path = window.location.pathname.replace(/\/$/, '') || '/';
      var handlePath = '/collections/' + BEST_SELLER_COLLECTION_HANDLE;
      if (path !== handlePath) return;
      var params = new URLSearchParams(window.location.search);
      if (params.get('sort_by') === BEST_SELLER_SORT_VALUE) return;
      params.set('sort_by', BEST_SELLER_SORT_VALUE);
      window.location.replace(path + '?' + params.toString());
    } catch (e) {
      /* ignore */
    }
  })();

  /* ---------- boot ---------- */
  function boot() {
    readConfig();
    applySavedView(getSectionEl());
    sortByOrderCount(getSectionEl());
    initCollectionSearch();
    reinitLazyImages(getSectionEl());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
